<div class="flex-column gap-small">
    <div class="input-grid-gaps-small entries-wrapper">
        @for (item of store.dataInfo(); track $index) {
            <div>{{ item.key | translate }}:</div>
            <div>{{ item.value }}</div>
        }
    </div>

    @if (store.isSocial()) {
        <p-divider></p-divider>
        <div class="flex gap align-items-end justify-content-end">
            <app-select-input
                [infiniteScroll]="processesScroll()"
                [form]="formProcesses"
                id="process"
                [label]="primaryContactDateLabel()?.labelDateInfo ?? 'person.dashboard.importantInfo.request'"
                class="align-self-end pt-2 process-selector"
                [valueKey]="null"
                [showClear]="false"
                [autoDisplayFirst]="true"
                size="small"
            >
                <ng-template #item let-item>
                    <div class="flex-column gap-xx-small">
                        <span>
                            {{ item.labelDateInfo | translate }}
                        </span>
                        <small class="font-size-x-small text-secondary">
                            {{ item.labelDate | shortDate }}
                        </small>
                    </div>
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item.labelDate | shortDate }}
                </ng-template>
            </app-select-input>

            @if (store.multiContractsAllowed()) {
                <app-button
                    icon="pi-plus"
                    size="small"
                    [pTooltip]="store.prefix + 'messages.addNewRequest' | translate"
                    (clickEvent)="addRequest($event)"
                ></app-button>
            }
        </div>

        @if (formActProcess.value.id) {
            <div class="input-grid-gaps-small entries-wrapper">
                <div class="flex gap-x-small align-items-center">
                    @if (primaryContactDateLabel()?.labelDateInfo) {
                        <span>{{ primaryContactDateLabel()!.labelDateInfo | translate }}</span>
                    }
                    <app-link-button
                        icon="pi-pencil"
                        (clickEvent)="openLabelDialog()"
                    ></app-link-button>
                    :
                </div>
                <app-date-input
                    [form]="formActProcess"
                    id="primaryContactDate"
                    [showLabel]="false"
                    size="small"
                ></app-date-input>

                @if (store.actFolderStatus() === FolderServiceTypeSocialStatusEnum.APPLICANT && !formActProcess.value.requestDate) {
                    <div>{{ store.prefix + 'applicantInactiveFrom' | translate }}:</div>
                    <app-date-input
                        [form]="formActProcess"
                        id="applicantInactiveFrom"
                        [showLabel]="false"
                        size="small"
                    ></app-date-input>
                }
                @if (!formActProcess.value.applicantInactiveFrom) {
                    <p-fieldset class="fr-2">
                        <ng-template #header>
                            <div>{{ store.prefix + 'request' | translate }}</div>
                        </ng-template>

                        <ng-template #content>
                            <div class="input-grid-gaps-small entries-wrapper">
                                <div>{{ store.prefix + 'requestDate' | translate }}:</div>
                                <app-date-input
                                    [form]="formActProcess"
                                    id="requestDate"
                                    [showLabel]="false"
                                    size="small"
                                ></app-date-input>
                                @if (formActProcess.value.requestDate) {
                                    @if (!formActProcess.value.requestApproveDate && !formProcesses.value.process?.contractId || formActProcess.value.requestCancellingDate) {
                                        <div>{{ store.prefix + 'requestCancellingDate' | translate }}:</div>
                                        <app-date-input
                                            [form]="formActProcess"
                                            id="requestCancellingDate"
                                            [showLabel]="false"
                                            size="small"
                                        ></app-date-input>
                                    }
                                    @if (formActProcess.value.requestCancellingDate) {
                                        <div>{{ store.prefix + 'requestCancellingReason' | translate }}:</div>
                                        <app-select-input
                                            [form]="formActProcess"
                                            id="requestCancellingReason"
                                            [staticOptions]="folderServiceSocialRequestRejectReasonOptions"
                                            [showLabel]="false"
                                            size="small"
                                            valueKey="value"
                                        ></app-select-input>
                                    }
                                    @if (!formActProcess.value.wishToBeInWaitingList && !formProcesses.value.process?.contractId) {
                                        <div>{{ store.prefix + 'requestApproveDate' | translate }}:</div>
                                        <app-date-input
                                            [form]="formActProcess"
                                            id="requestApproveDate"
                                            [showLabel]="false"
                                            size="small"
                                        ></app-date-input>
                                    }
                                    @if (!formActProcess.value.requestApproveDate && !formActProcess.value.wishToBeInWaitingList && !formProcesses.value.process?.contractId) {
                                        <div>{{ store.prefix + 'requestWithdrawnDate' | translate }}:</div>
                                        <app-date-input
                                            [form]="formActProcess"
                                            id="requestWithdrawnDate"
                                            [showLabel]="false"
                                            size="small"
                                        ></app-date-input>
                                    }
                                }
                            </div>
                        </ng-template>
                    </p-fieldset>
                }

                @if (formActProcess.value.requestCancellingReason === FolderServiceSocialRequestRejectReasonEnum.PROVIDER_HAS_NO_AVAILABLE_CAPACITY) {
                    @if (store.currentService()?.social?.useWaitingList && (!formActProcess.value.requestWithdrawnDate || formProcesses.value.process?.waitingList)) {
                        <div class="fr-2 pt-3 justify-self-start">
                            <app-check-input
                                [form]="formActProcess"
                                id="wishToBeInWaitingList"
                                [label]="store.prefix + 'wishToBeInWaitingList'"
                                size="small"
                            ></app-check-input>
                        </div>

                        @if (formActProcess.value.wishToBeInWaitingList) {
                            <p-fieldset class="fr-2">
                                <ng-template #header>
                                    <div class="flex gap-x-small align-items-center">
                                        <div>{{ 'waitingList.title' | translate }}</div>
                                        @if (formProcesses.value.process?.waitingList) {
                                            <app-link-button
                                                icon="pi-pencil"
                                                (clickEvent)="openWaitingListDetail(formProcesses.value.process?.waitingList)"
                                            ></app-link-button>
                                        }
                                    </div>
                                </ng-template>

                                <ng-template #content>
                                    <div class="input-grid-gaps-small entries-wrapper">
                                        <div>{{ store.prefix + 'overallScore' | translate }}:</div>
                                        {{ formProcesses.value.process?.waitingList?.ratingPoints || 0 }}

                                        <div>{{ store.prefix + 'readyToUseService' | translate }}:</div>
                                        <div>{{ (formProcesses.value.process?.waitingList?.readyToUseService ? 'yes' : 'no') | translate }}</div>

                                        @if (formProcesses.value.process?.waitingList?.note) {
                                            <div>{{ store.prefix + 'note' | translate }}:</div>
                                            <app-strip-and-show
                                                [text]="formProcesses.value.process?.waitingList?.note || ''"
                                                [length]="50"
                                            ></app-strip-and-show>
                                        }

                                        @if (formProcesses.value.process?.waitingList?.dateTo) {
                                            <div>{{ store.prefix + 'waitingListRemovalDate' | translate }}:</div>
                                            <div>{{ formProcesses.value.process?.waitingList?.dateTo | shortDate }}</div>
                                        }

                                        @if (formProcesses.value.process?.waitingList?.removalReason) {
                                            <div>{{ store.prefix + 'waitingListRemovalReason' | translate }}:</div>
                                            @if (formProcesses.value.process?.waitingList?.removalReason) {
                                                <div>{{ 'waitingList.enums.removalReason.' + formProcesses.value.process?.waitingList?.removalReason | translate }}</div>
                                            }
                                        }
                                    </div>
                                </ng-template>
                            </p-fieldset>
                        }
                    }
                }

                @if (formActProcess.value.requestApproveDate) {
                    @if (!store.actIndividualPlan()) {
                        <div>{{ store.prefix + 'ip' | translate }}:</div>
                        <app-link-button
                            [label]="store.prefix + 'createNewIP'"
                            (clickEvent)="openIPDetail()"
                        ></app-link-button>
                    } @else {
                        <p-fieldset class="fr-2">
                            <ng-template #header>
                                <div class="flex gap-x-small align-items-center">
                                    <div>{{ 'individualPlan.label' | translate }}</div>
                                    <app-link-button
                                        icon="pi-pencil"
                                        (clickEvent)="openIPDetail()"
                                    ></app-link-button>
                                </div>
                            </ng-template>

                            <ng-template #content>
                                <div class="input-grid-gaps-small entries-wrapper">
                                    @for (target of store.actIndividualPlan().targets; track target.id) {
                                        <app-tag
                                            [severity]="$any(individualPlanTargetStatusColor)[target.status]"
                                            [label]="'individualPlan.target.status.' + target.status"
                                            [rounded]="true"
                                        ></app-tag>
                                        <div>{{ target.name }}</div>
                                    }
                                </div>
                            </ng-template>
                        </p-fieldset>
                    }
                }

                @if (formActProcess.value.requestApproveDate || formProcesses.value.process?.contractId) {
                    <div>{{ store.prefix + 'contract' | translate }}:</div>
                    <app-link-button
                        [label]="contractInfo()"
                        (clickEvent)="openContractDialog(formProcesses.value.process?.contractId)"
                    ></app-link-button>
                }
            </div>
        } @else {
            <app-empty-state></app-empty-state>
        }
    }
</div>
